
import { mapMutations, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'mobileMenuOpen',
      'mobileLinks'
    ]),
    pagePath() {
      const page = this.$route.path || '';
      const trimmedPage = '/' + page.split('/')[1];
      return trimmedPage;
    }
  },
  methods: {
    ...mapMutations([
      'closeMobileMenu'
    ]),
    goTo(path) {
      this.$router.push(path);
      this.closeMobileMenu();
    },
  },
  watch: {
    mobileMenuOpen(open) {
      // Disable all expandables in menu when mobile menu (navigation menu) closes
      if (!open) {
        this.active = null;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./components/mixins/Navigation.vue